import React, {Component} from 'react'
import {Accordion, Icon, Label} from 'semantic-ui-react'

// Containers for POs that have already been received - they are gone from the open PO report,
// so these come from what we recorded while each PO was still open.
class ClosedPoAccordion extends Component {
  constructor(props) {
    super(props)
    this.state = {active: false}
  }

  toggleAccordion = () => this.setState({active: !this.state.active})

  render() {
    let {rows, expandAll} = this.props
    let {active} = this.state

    if (expandAll) {
      active = true
    }

    // number of POs behind these containers - one PO can span more than one container
    const total = [...new Set(rows.map(row => row[0]))].length

    return (
      <Accordion>
        <Accordion.Title onClick={expandAll ? () => {} : this.toggleAccordion}>
          <Icon name='ship'/>
          Received Containers ({total})
          {
            total > 0
            ?
            <Icon name='dropdown' style={active ? {rotate: '90deg'} : {rotate: '180deg'}}/>
            :
            null
          }
        </Accordion.Title>
        <Accordion.Content active={active && total > 0}>
          <div style={{marginLeft: '21px'}}>
            {rows.map((row, index) =>
              <div key={index} style={{marginBottom: '4px'}}>
                <span style={{marginRight: '8px'}}>{row[0]}</span>
                <Label>{row[1]}</Label>
              </div>
            )}
          </div>
        </Accordion.Content>
      </Accordion>
    )
  }
}

export default ClosedPoAccordion
